<template>
    <!--<div class="refresh" v-if="!networkSuccess">-->
    <div class="refresh">
        <div>
            <img src="@/assets/img/no-internet.png" alt="">
        </div>
        <p>暂无网络</p>
        <br>
        <button @click="onRefresh()">点我刷新</button>
    </div>
</template>
<script>
    import {mapState } from 'vuex';
    export default {
        name: '',
        data() {
            return {}
        },
        methods: {
            onRefresh(){
                this.$router.go(-1)//返回之前点击的页面
            },
        },
        computed:{
            ...mapState(['networkSuccess'])
        },
    }
</script>
<style scoped="">
    .refresh{
        color: #888;
        font-size: 14px;
        text-align: center;
        padding-top: 30px;
    }
    .refresh img{
        width: 190px;
    }
    .refresh button{
        color: #666;
    }
</style>


// WEBPACK FOOTER //
// src/pages/refresh.vue